module.exports = __webpack_public_path__ + "img/fonetti-logo.c14d72c2.svg";